import React from "react"
import "twin.macro"
import { StaticImage } from "gatsby-plugin-image"
import { graphql, useStaticQuery } from "gatsby"
import {
  GatsbyImage,
  getImage,
  IGatsbyImageData,
  ImageDataLike,
} from "gatsby-plugin-image"

type dataType = {
  allRefJson: {
    nodes: {
      name: String
      desc: String
      company: String
      image: ImageDataLike
    }[]
  }
  allClientsJson: {
    nodes: {
      image: ImageDataLike
    }[]
  }
  allInterestJson: {
    nodes: {
      name: String
      image: ImageDataLike
    }[]
  }
}

const Reference = () => {
  const data: dataType = useStaticQuery(graphql`
    query RefQuery {
      allRefJson {
        nodes {
          name
          desc
          company
          image {
            childImageSharp {
              gatsbyImageData
            }
          }
        }
      }
      allClientsJson {
        nodes {
          image {
            childImageSharp {
              gatsbyImageData
            }
          }
        }
      }
      allInterestJson {
        nodes {
          name
          image {
            childImageSharp {
              gatsbyImageData
            }
          }
        }
      }
    }
  `)
  const AllData = data.allRefJson.nodes
  const cdata = data.allClientsJson.nodes
  const idata = data.allInterestJson.nodes
  return (
    <>
      {/* middle side */}
      <div tw="bg-white max-w-3xl md:col-span-5 shadow-2xl">
        <h1 tw="mt-3.5 ml-4 text-2xl font-semibold pt-8 pl-6">REFERENCES</h1>
        <div tw="container p-14 ">
          {AllData.map((item, index) => {
            const image = getImage(item.image)
            return (
              <div tw="container flex">
                <div tw=" h-20 w-20 object-cover rounded-full">
                  <GatsbyImage image={image as IGatsbyImageData} alt="photo" />
                </div>
                <div>
                  <h2 tw="pl-4 font-semibold">{item.name}</h2>
                  <h2 tw="pl-4 pt-2 font-semibold opacity-50">
                    {item.company}
                  </h2>
                  <h1 tw="p-4 ">{item.desc}</h1>
                  <hr tw="m-3" />
                </div>
              </div>
            )
          })}
        </div>

        <h1 tw="ml-4 text-2xl font-semibold pl-4">CLIENTS</h1>
        <br tw="m-3" />
        <br tw="m-3" />
        <br tw="m-3" />
        <hr tw="m-3" />
        <h1 tw="ml-4 text-2xl font-semibold pl-4">INTERESTS</h1>
        <div tw="grid grid-cols-3 gap-4 p-6">
          {idata.map((item, index) => {
            const image = getImage(item.image)
            return (
              <div tw="flex p-2">
                <GatsbyImage
                  image={image as IGatsbyImageData}
                  alt="photo"
                  tw="h-6 w-6"
                />
                <div tw="font-light text-base">{item.name}</div>
              </div>
            )
          })}
        </div>
      </div>
    </>
  )
}
export default Reference
//https://images.pexels.com/photos/3671083/pexels-photo-3671083.jpeg?auto=compress&cs=tinysrgb&dpr=3&h=100&w=600
//tw=" h-10 w-20 object-cover rounded-full"
